<div class="date">
  <input
    data-cy="input-dob-day"
    class="form-input"
    type="text"
    pattern="\d*"
    maxlength="2"
    [ngClass]="invalidDate ? 'invalid' : ''"
    [value]="savedDOB[2]"
    (keypress)="allowNumericInputOnly($event)"
    (input)="saveDOB($event, 'day')"
    [placeholder]="'account.personal-information.labels._dob.day' | translate"
    required
  />
  <input
    data-cy="input-dob-month"
    class="form-input"
    type="text"
    pattern="\d*"
    maxlength="2"
    [ngClass]="invalidDate ? 'invalid' : ''"
    [value]="savedDOB[1]"
    (keypress)="allowNumericInputOnly($event)"
    (input)="saveDOB($event, 'month')"
    [placeholder]="'account.personal-information.labels._dob.month' | translate"
    required
  />
  <input
    data-cy="input-dob-year"
    class="form-input"
    type="text"
    pattern="\d*"
    maxlength="4"
    [ngClass]="invalidDate ? 'invalid' : ''"
    [value]="savedDOB[0]"
    (keypress)="allowNumericInputOnly($event)"
    (input)="saveDOB($event, 'year')"
    [placeholder]="'account.personal-information.labels._dob.year' | translate"
    required
  />
</div>
